import { captureException } from "@sentry/browser";
import { Dispatch } from "redux";
import { AxiosInstance } from "axios";
import { showNotification } from "../../notification/actions";

import { SET_PLAN_TITLE } from "../types";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";
import { IPlan } from "../../../../common/types";

export default (data: { planId: string, name: IPlan["name"]}, callback: (res: boolean) => void) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<{ success: boolean }>("/rename-plan", data);
        dispatch({
            type: SET_PLAN_TITLE,
            payload: { ...res, ...data, user: getState().user },
        });
        if (callback) {
            callback(true);
        }
    } catch (error) {
        if (callback) {
            callback(false);
        }
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};
